import { getOfferApi } from './get-offer.config';

export const {
  getOffer,
  getOfferClear,
  getOfferError,
  getOfferSuccess,
  getOfferActions,
} = getOfferApi;
